// Catálogo de productos B2B hostelería en España
// Organizado por categorías para facilitar navegación

export const PRODUCT_CATEGORIES = {
  'Refrescos y Bebidas': [
    'Coca-Cola',
    'Coca-Cola Zero',
    'Fanta Naranja',
    'Fanta Limón',
    'Pepsi',
    'Pepsi Max',
    'Sprite',
    'Nestea',
    'Aquarius Naranja',
    'Aquarius Limón',
    'Red Bull',
    'Monster Energy',
    'Agua Mineral (Bezoya)',
    'Agua Mineral (Font Vella)',
    'Agua con Gas (Vichy)',
    'Zumo de Naranja (Don Simón)',
    'Zumo de Piña',
    'Tónica Schweppes',
    'Bitter Kas',
  ],
  'Cervezas': [
    'Estrella Damm',
    'Estrella Galicia',
    'Mahou 5 Estrellas',
    'Mahou Clásica',
    'San Miguel',
    'Cruzcampo',
    'Alhambra Especial',
    'Voll-Damm',
    'Heineken',
    'Corona Extra',
    'Cerveza Sin Alcohol',
  ],
  'Vinos y Licores': [
    'Vino Rioja Tinto',
    'Vino Ribera del Duero',
    'Vino Rueda Blanco',
    'Vino Albariño',
    'Cava Freixenet',
    'Cava Codorníu',
    'Vermut Rojo',
    'Ginebra Beefeater',
    'Ginebra Bombay Sapphire',
    'Ron Bacardi',
    'Whisky J&B',
    'Whisky Ballantines',
    'Vodka Absolut',
    'Licor 43',
    'Baileys',
  ],
  'Carnes y Embutidos': [
    'Jamón Ibérico',
    'Jamón Serrano',
    'Chorizo',
    'Salchichón',
    'Lomo Embuchado',
    'Fuet',
    'Pollo Entero',
    'Pechuga de Pollo',
    'Solomillo de Cerdo',
    'Entrecot de Ternera',
    'Costillas de Cerdo',
    'Panceta',
    'Bacon',
    'Carne Picada',
    'Hamburguesa',
    'Cordero',
  ],
  'Pescados y Mariscos': [
    'Merluza Fresca',
    'Salmón Fresco',
    'Atún',
    'Bacalao',
    'Dorada',
    'Lubina',
    'Boquerones',
    'Sardinas',
    'Pulpo',
    'Calamares',
    'Sepia',
    'Gambas',
    'Langostinos',
    'Mejillones',
    'Almejas',
    'Navajas',
  ],
  'Frutas y Verduras': [
    'Tomate',
    'Tomate Cherry',
    'Aguacate',
    'Lechuga Iceberg',
    'Lechuga Romana',
    'Rúcula',
    'Espinacas',
    'Patatas',
    'Cebolla',
    'Cebolla Morada',
    'Ajo',
    'Pimiento Rojo',
    'Pimiento Verde',
    'Zanahorias',
    'Calabacín',
    'Berenjena',
    'Pepino',
    'Champiñones',
    'Setas Portobello',
    'Manzana Golden',
    'Naranjas',
    'Limones',
    'Plátanos',
    'Fresas',
    'Uvas',
    'Piña',
    'Sandía',
    'Melón',
  ],
  'Lácteos y Huevos': [
    'Leche Entera (Pascual)',
    'Leche Semidesnatada',
    'Leche Desnatada',
    'Nata para Cocinar',
    'Mantequilla',
    'Queso Manchego',
    'Queso Cabra',
    'Queso Parmesano',
    'Queso Mozzarella',
    'Queso Cheddar',
    'Queso Feta',
    'Yogur Natural',
    'Huevos Frescos L',
    'Huevos Camperos',
  ],
  'Aceites y Vinagres': [
    'Aceite Oliva Virgen Extra',
    'Aceite Oliva Suave',
    'Aceite Girasol',
    'Vinagre de Jerez',
    'Vinagre Balsámico',
    'Vinagre de Manzana',
  ],
  'Panadería y Repostería': [
    'Pan de Barra',
    'Pan Rústico',
    'Pan de Molde (Bimbo)',
    'Pan Hamburguesa',
    'Pan Hot Dog',
    'Croissants',
    'Napolitana Chocolate',
    'Magdalenas',
    'Bizcocho',
    'Harina de Trigo',
  ],
  'Legumbres, Arroz y Pasta': [
    'Arroz Bomba',
    'Arroz Redondo (SOS)',
    'Arroz Basmati',
    'Pasta Spaghetti',
    'Pasta Macarrones',
    'Pasta Lasaña',
    'Lentejas',
    'Garbanzos',
    'Alubias Blancas',
    'Quinoa',
    'Cous Cous',
  ],
  'Conservas y Salsas': [
    'Tomate Frito (Solís)',
    'Tomate Triturado',
    'Atún en Aceite',
    'Aceitunas Verdes',
    'Aceitunas Negras',
    'Mayonesa (Hellmann\'s)',
    'Ketchup Heinz',
    'Mostaza',
    'Salsa de Soja',
    'Salsa BBQ',
  ],
  'Café e Infusiones': [
    'Café en Grano (Marcilla)',
    'Café Molido',
    'Café Cápsulas Nespresso',
    'Té Verde',
    'Té Negro',
    'Manzanilla',
    'Poleo Menta',
  ],
  'Snacks y Otros': [
    'Patatas Fritas Lays',
    'Frutos Secos Variados',
    'Palomitas',
    'Chocolate Negro',
    'Azúcar Blanco',
    'Sal Marina',
    'Servilletas de Papel',
    'Papel Aluminio',
    'Film Transparente',
  ],
};

// Lista plana de todos los productos (para búsqueda / compatibilidad)
export const PRODUCTS = Object.values(PRODUCT_CATEGORIES).flat();

// Formatos agrupados por tipo para el Select
export const FORMAT_CATEGORIES = {
  'Peso y cantidad': [
    'Unidades',
    'Docenas',
    'Kg',
    'Gramos',
  ],
  'Cajas y packs': [
    'Cajas',
    'Packs',
    'Sacos',
    'Bandejas',
  ],
  'Botellas de cristal': [
    'Botella cristal 20cl',
    'Botella cristal 33cl',
    'Botella cristal 50cl (medio litro)',
    'Botella cristal 75cl',
    'Botella cristal 1L',
    'Botella cristal 1.5L',
    'Botella cristal 2L',
  ],
  'Botellas de plástico': [
    'Botella plástico 33cl',
    'Botella plástico 50cl (medio litro)',
    'Botella plástico 1L',
    'Botella plástico 1.5L',
    'Botella plástico 2L',
    'Botella plástico 5L',
    'Botella plástico 8L',
  ],
  'Latas': [
    'Lata 25cl',
    'Lata 33cl',
    'Lata 50cl (medio litro)',
  ],
  'Barriles y garrafas': [
    'Barril 20L',
    'Barril 30L',
    'Barril 50L',
    'Garrafa 5L',
    'Garrafa 10L',
    'Garrafa 25L',
  ],
  'Volumen general': [
    'Litros',
  ],
};

// Lista plana de todos los formatos (compatibilidad y validación)
export const FORMATS = Object.values(FORMAT_CATEGORIES).flat();
